import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-modal__header" }
const _hoisted_2 = { class: "app-modal__title" }
const _hoisted_3 = { class: "app-modal__body" }
const _hoisted_4 = { class: "app-modal__footer" }

import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

interface Props {
    visible: boolean
    title: string
    actionLabel?: string
    actionDisabled?: boolean
    width?: string
    height?: string
    actionWidth?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppModal',
  props: {
    visible: { type: Boolean },
    title: {},
    actionLabel: { default: 'Save' },
    actionDisabled: { type: Boolean, default: false },
    width: { default: '930px' },
    height: { default: '' },
    actionWidth: { default: '156px' }
  },
  emits: ["update:visible", "cancel", "action"],
  setup(__props: any, { emit: __emit }) {

/* eslint-env vue/setup-compiler-macros */


const emit = __emit;

function close() {
    emit('update:visible', false);
    emit('cancel');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: __props.visible,
    modal: "",
    blockScroll: true,
    closable: false,
    draggable: false,
    style: _normalizeStyle({ width: __props.width, height: __props.height || undefined }),
    pt: {
            root: { class: 'app-modal' },
            header: { style: { display: 'none' } },
            content: { class: 'app-modal__content' },
            footer: { style: { display: 'none' } },
            mask: { class: 'app-modal__mask' },
        },
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (emit('update:visible', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1),
        _createElementVNode("button", {
          type: "button",
          class: "app-modal__close",
          "aria-label": "Close",
          onClick: close
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", {
            class: "pi pi-times",
            "aria-hidden": "true"
          }, null, -1)
        ]))])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "app-modal__hr",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "app-modal__hr",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "footer", {}, () => [
          _createVNode(_unref(Button), {
            type: "button",
            label: "Cancel",
            class: "app-modal__cancel-btn",
            onClick: close
          }),
          _createVNode(_unref(Button), {
            type: "button",
            label: __props.actionLabel,
            disabled: __props.actionDisabled,
            class: "app-modal__action-btn",
            style: _normalizeStyle({ width: __props.actionWidth }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('action')))
          }, null, 8, ["label", "disabled", "style"])
        ])
      ])
    ]),
    _: 3
  }, 8, ["visible", "style"]))
}
}

})